import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { savePostLoginRedirect } from '@/lib/auth/postLoginRedirect'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuthStore()
  const location = useLocation()

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    savePostLoginRedirect(`${location.pathname}${location.search}${location.hash}`)
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

